// src/services/AccountService.ts
import { collection, deleteDoc, doc, getDocs, query, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Account, Integration } from "@visitproof/types";

export const AccountService = {
  async getAccountIntegrations(accountId: string): Promise<Integration[]> {
    try {
      const snapshot = await getDocs(
        query(collection(db, "accounts", accountId, "integrations")),
      );
      return snapshot.docs.map(
        (doc) => ({ id: doc.id, ...doc.data() }) as Integration,
      );
    } catch (error) {
      console.error(`Error fetching account integrations:`, error);
      throw new Error(`Failed to get case visits: ${error}`);
    }
  },

  async deleteAccountIntegration(accountId: string, integrationId: string) {
    try {
      await deleteDoc(
        doc(db, "accounts", accountId, "integrations", integrationId),
      );
    } catch (error) {
      console.error(`Error deleting integration:`, error);
      throw new Error(`Failed to delete integration: ${error}`);
    }
  },

  async updateAccount(
    accountId: string,
    data: Partial<Omit<Account, "id" | "createdAt" | "updatedAt">>,
  ) {
    try {
      await updateDoc(doc(db, "accounts", accountId), data);
    } catch (error) {
      console.error(`Error updating account:`, error);
      throw new Error(`Failed to update account: ${error}`);
    }
  },

  async markOnboardingComplete(accountId: string) {
    return this.updateAccount(accountId, { isOnboardingComplete: true });
  },
};
